import type { Filesystem } from '@gitbook/openapi-parser';
import {
    OpenAPIOperation as BaseOpenAPIOperation,
    type OpenAPIOperationData,
} from '@gitbook/react-openapi';
import { PlainCodeBlock } from '@gitbook/react-uikit';
import type { DocumentJSON } from '@gitbook/slate';
import { Icon } from '@gitbook/spine-icons';
import { Heading } from '@gitbook/spine-react';

import { OpenAPIBlockContent } from './OpenAPIBlockContent';
import { OpenAPIDocumentRenderer } from './OpenAPIDocumentRenderer';
import { useResolveOpenAPI } from './useResolveOpenAPI';

/**
 * Content of an OpenAPI operation block.
 */
export function OpenAPIOperationBlockContent(props: {
    specUrl: string;
    filesystem: Filesystem;
    path: string;
    method: string;
}) {
    const { specUrl, filesystem, path, method } = props;

    const result = useResolveOpenAPI<OpenAPIOperationData>({ filesystem, path, method });

    return (
        <OpenAPIBlockContent name={`${method} ${path}`} type="operation" resolved={result}>
            {({ data }) => (
                <BaseOpenAPIOperation
                    data={data}
                    context={{
                        locale: 'en',
                        icons: {
                            chevronDown: <Icon.ChevronDown />,
                            chevronRight: <Icon.ChevronRight />,
                            plus: <Icon.Plus />,
                        },
                        renderCodeBlock: (codeProps) => (
                            <PlainCodeBlock className="openapi-codeblock" {...codeProps} />
                        ),
                        renderHeading: ({ deprecated, title }) => (
                            <Heading className={deprecated ? 'line-through' : undefined} level={2}>
                                {title}
                            </Heading>
                        ),
                        renderDocument: ({ document }: { document: DocumentJSON }) => {
                            return <OpenAPIDocumentRenderer document={document} />;
                        },
                        defaultInteractiveOpened: false,
                        specUrl,
                    }}
                    className="openapi-block"
                />
            )}
        </OpenAPIBlockContent>
    );
}
